import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";

// Deliberately excluded from sitemap.xml: a sign-in screen has no search value.
export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Sign In | Garden-Review" },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Sign in to your Garden-Review account to comment, submit content and manage submissions.",
      },
    ],
  }),
  component: Auth,
});
